@if (visible()) {
  <div
    class="bai-slash-menu"
    role="listbox"
    aria-label="Slash commands"
    (keydown)="onKeydown($event)"
  >
    <div class="bai-slash-menu__header">
      <span class="bai-slash-menu__title">Commands</span>
      <button
        type="button"
        class="bai-slash-menu__close"
        aria-label="Close command menu"
        (click)="onEscape()"
      >
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>

    @if (filteredCommands().length === 0) {
      <div class="bai-slash-menu__empty">No commands match "{{ query() }}"</div>
    } @else {
      @for (cmd of filteredCommands(); track cmd.id; let i = $index) {
        <button
          type="button"
          class="bai-slash-menu__item"
          [class.bai-slash-menu__item--active]="i === activeIndex()"
          role="option"
          [attr.aria-selected]="i === activeIndex()"
          (click)="selectCommand(cmd)"
          (mouseenter)="activeIndex.set(i)"
        >
          <span class="bai-slash-menu__command">{{ cmd.command }}</span>
          <span class="bai-slash-menu__description">{{ cmd.description }}</span>
          @if (cmd.isDemo) {
            <span class="bai-slash-menu__demo-badge" aria-label="Demo only">Demo</span>
          }
        </button>
      }
    }
  </div>
}
